import dayjs from 'dayjs';

function formatTime(format:string,time?:string){
    return dayjs(time).utc().local().format(format)

}
export default formatTime
